import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="February 6, 2026">
      <p>
        By creating an account or booking a pickup on Foldora, you agree to the following Terms &amp; Conditions.
      </p>
      <h2>1. Service</h2>
      <p>
        Foldora provides laundry pickup and delivery within our service areas, on Mondays, Wednesdays, and Fridays
        (pickup, 9–11 AM) with drop-off on Tuesdays, Thursdays, and Saturdays (3–6 PM). Express same-day delivery
        is available at a $15 surcharge.
      </p>
      <h2>2. Account</h2>
      <p>
        You must provide accurate contact and address information. You are responsible for activity on your account.
      </p>
      <h2>3. Pricing</h2>
      <ul>
        <li>Minimum order: $50 (includes the first 25 lbs).</li>
        <li>Additional weight: $2 per lb after 25 lbs.</li>
        <li>Oversized items (comforters, blankets, drapes): +$1 per item.</li>
        <li>Optional add-ons: Ironing +$15, Steaming +$10.</li>
        <li>Applicable taxes (GST 5% + HST 13%) are added to every invoice.</li>
      </ul>
      <h2>4. Payment</h2>
      <p>
        You may pay online (Stripe or PayPal) at booking, or cash on delivery. Unpaid COD orders must be settled at drop-off.
      </p>
      <h2>5. Cancellation</h2>
      <p>
        You may cancel a pickup up to 12 hours before its scheduled time at no charge. Late cancellations incur a $10 fee.
      </p>
      <h2>6. Liability</h2>
      <p>
        Our liability for lost or damaged garments is limited as described in the Damage Policy.
      </p>
      <h2>7. Changes</h2>
      <p>
        We may update these terms; continued use of the service after changes constitutes acceptance.
      </p>
      <h2>8. Governing law</h2>
      <p>These terms are governed by the laws of the Province of Ontario, Canada.</p>
    </LegalLayout>
  );
}
